import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormatPipe } from '../../../pipes/format.pipe';

/**
 * Use as a placeholder until actual implementations are available.
 */
@Component({
  selector: 'app-percent-bar-chart',
  imports: [CommonModule, FormatPipe],
  template: ` <div
      class="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-1.5"
    >
      <div>
        <div
          class="tw-font-bold tw-text-[1rem] tw-text-[var(--sed-black-60-color)]"
        >
          {{ totalLabel }}
        </div>
        <div class="tw-font-bold tw-text-[1.6rem]">
          {{ totalValue | format: 'c' }}
        </div>
      </div>
      <div
        class="tw-rounded-xl tw-text-[2rem] tw-font-bold tw-px-3 tw-bg-[var(--sed-open-grey-color)] "
        [style.background-color]="color"
      >
        {{ totalPercent ?? 0 | number: '1.0-0' }}%
      </div>
    </div>
    <div class="tw-w-full tw-pb-1">
      <div
        class="tw-rounded-2xl tw-min-w-full tw-bg-[var(--sed-open-grey-color)] tw-p-1"
      >
        <div
          class="tw-rounded-xl tw-h-4 "
          [style.background-color]="color"
          [style.width]="totalPercent + '%'"
        ></div>
      </div>
    </div>
    <div
      class="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-1.5 tw-pb-6"
    >
      <div>
        <div
          class="tw-font-bold tw-text-[0.9rem] tw-text-[var(--sed-black-60-color)]"
        >
          {{ leftLabel }}: {{ leftValue | format: 'c' }}
        </div>
      </div>
      <div>
        <div
          class="tw-font-bold tw-text-[0.9rem] tw-text-[var(--sed-black-60-color)]"
        >
          {{ rightLabel }}: {{ rightValue | format: 'c' }}
        </div>
      </div>
    </div>`,
  styles: ``,
})
export class PercentBarChartComponent {
  @Input()
  label: string;

  @Input()
  totalLabel: string;

  @Input()
  totalValue: number;

  @Input()
  totalPercent: number;

  @Input()
  color = 'var(--sed-purple-40-color)';

  @Input()
  leftLabel: string;

  @Input()
  leftValue: number;

  @Input()
  rightLabel: string;

  @Input()
  rightValue: number;
}
